const IntroSection = ({ item }: any) => {
  return (
    <>
      <div className="block sm:hidden bg-[#EEF4FF] p-5 px-2 mb-8">
        <div className="flex items-center justify-center min-w-[fit-content] flex-wrap">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 11.5667C8.60015 11.5667 9.08666 11.0802 9.08666 10.48C9.08666 9.87989 8.60015 9.39337 8 9.39337C7.39985 9.39337 6.91333 9.87989 6.91333 10.48C6.91333 11.0802 7.39985 11.5667 8 11.5667Z"
              fill="#667085"
            />
            <path
              d="M12.1866 6.35331V5.51998C12.1866 3.71998 11.7533 1.33331 7.99998 1.33331C4.24665 1.33331 3.81331 3.71998 3.81331 5.51998V6.35331C1.94665 6.58665 1.33331 7.53331 1.33331 9.85998V11.1C1.33331 13.8333 2.16665 14.6666 4.89998 14.6666H11.1C13.8333 14.6666 14.6666 13.8333 14.6666 11.1V9.85998C14.6666 7.53331 14.0533 6.58665 12.1866 6.35331ZM7.99998 12.4933C6.88665 12.4933 5.98665 11.5866 5.98665 10.48C5.98665 9.36665 6.89331 8.46665 7.99998 8.46665C9.10665 8.46665 10.0133 9.37331 10.0133 10.48C10.0133 11.5933 9.11331 12.4933 7.99998 12.4933ZM4.89998 6.29331C4.84665 6.29331 4.79998 6.29331 4.74665 6.29331V5.51998C4.74665 3.56665 5.29998 2.26665 7.99998 2.26665C10.7 2.26665 11.2533 3.56665 11.2533 5.51998V6.29998C11.2 6.29998 11.1533 6.29998 11.1 6.29998H4.89998V6.29331Z"
              fill="#667085"
            />
          </svg>{" "}
          Your account isn’t fully activated.
        </div>
        <div className="flex flex-wrap justify-center text-center min-w-0">
          <span className="text-[#2C53F2] mr-1 break-words">
            Complete registration
          </span>
          to access all benefits.
        </div>
      </div>
      <div className="flex text-[16px] sm:justify-start justify-center font-[800] !text-[#344054] p-[1rem] py-0 sm:py-[1rem] sm:p-0">
        Hello John,{" "}
        <span className="ml-2">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.4"
              d="M21.25 9.14998C20.76 8.36998 20.2 7.66998 19.62 7.03998L15.85 10.81C15.97 11.18 16.04 11.58 16.04 12C16.04 14.24 14.23 16.04 12 16.04C11.58 16.04 11.18 15.97 10.81 15.85L7.34998 19.31C8.80998 20.13 10.39 20.56 12 20.56C13.78 20.56 15.51 20.04 17.09 19.07C18.67 18.09 20.09 16.66 21.25 14.84C22.25 13.28 22.25 10.72 21.25 9.14998Z"
              fill="#667085"
            />
            <path
              d="M14.02 9.98001L9.98001 14.02C9.47001 13.5 9.14001 12.78 9.14001 12C9.14001 10.43 10.42 9.14001 12 9.14001C12.78 9.14001 13.5 9.47001 14.02 9.98001Z"
              fill="#667085"
            />
            <path
              opacity="0.4"
              d="M18.25 5.74999L14.86 9.13999C14.13 8.39999 13.12 7.95999 12 7.95999C9.76 7.95999 7.96 9.76999 7.96 12C7.96 13.12 8.41 14.13 9.14 14.86L5.76 18.25H5.75C4.64 17.35 3.62 16.2 2.75 14.84C1.75 13.27 1.75 10.72 2.75 9.14999C3.91 7.32999 5.33 5.89999 6.91 4.91999C8.49 3.95999 10.22 3.42999 12 3.42999C14.23 3.42999 16.39 4.24999 18.25 5.74999Z"
              fill="#667085"
            />
            <path
              d="M14.86 12C14.86 13.57 13.58 14.86 12 14.86C11.94 14.86 11.89 14.86 11.83 14.84L14.84 11.83C14.86 11.89 14.86 11.94 14.86 12Z"
              fill="#667085"
            />
            <path
              d="M21.77 2.23C21.47 1.93 20.98 1.93 20.68 2.23L2.23 20.69C1.93 20.99 1.93 21.48 2.23 21.78C2.38 21.92 2.57 22 2.77 22C2.97 22 3.16 21.92 3.31 21.77L21.77 3.31C22.08 3.01 22.08 2.53 21.77 2.23Z"
              fill="#667085"
            />
          </svg>
        </span>
      </div>
      <div className="flex sm:justify-between  justify-center">
        <div className="flex items-center text-[#667085] p-[1rem] py-0 sm:py-[1rem] !pt-0 sm:p-0">
          Overview of your recent activity
        </div>
        <div className="text-[14px] hidden sm:flex sm:flex-nowrap flex-wrap"></div>
      </div>
    </>
  );
};

export default IntroSection;
